/* eslint-disable @next/next/no-img-element */
import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import styles from "@/src/styles/navbar.module.css";
import LanguageSelection from "@/src/Components/Navigation/LanguageSelection";
import { Box, Typography } from "@mui/material";
import NavbarUserMenu from "@/src/Components/Navigation/NavbarUserMenu";
import VerifyCertificateModal from "@/src/Components/Modals/VerifyCertificateModal";
import { translatedVariants } from "@/src/Utils/translationObject";
import { usePathname } from "next/navigation";

function Navbar(props: {
  logo: string;
  id: string;
  hideVerify?: boolean;
  setCurrentLanguage?: (lang: string) => void;
}) {
  const [menuState, setMenuState] = useState<{
    anchor: Element;
    id: string;
  } | null>(null);
  const [open, setOpen] = useState(false);
  const lang = props.id === "" ? "en" : props.id;
  const langObj = translatedVariants[lang] || translatedVariants.en;
  const pathname = usePathname();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenMenu = (event: React.MouseEvent<Element>, id: string) => {
    setMenuState({ anchor: event.currentTarget, id });
  };

  const handleCloseMenu = () => {
    setMenuState(null);
  };

  return (
    <AppBar
      position="static"
      color="transparent"
      elevation={0}
      sx={{
        p: "20px 0px",
      }}
      className={"topNavbar"}
    >
      <Container
        disableGutters={true}
        maxWidth={false}
        className={"containerWidth"}
      >
        <Toolbar>
          {!pathname.includes("/admin") && (
            <a href={lang === "en" || !lang ? "/" : `/${lang}`}>
              <img
                src={props.logo ? props.logo : "/images/logo.svg"}
                alt="Logo"
                className={styles.logo}
              />
            </a>
          )}
          {!pathname.includes("/admin") && !props.hideVerify ? (
            <>
              <Typography
                sx={{
                  marginLeft: "10px",
                  marginRight: "7px",
                  cursor: "pointer",
                  display: { xs: "none", sm: "block" },
                }}
                onClick={handleOpen}
              >
                {langObj.verification}
              </Typography>
            </>
          ) : (
            ""
          )}
          <div className={styles.spacer} />
          <LanguageSelection sx={{ marginRight: "10px" }} id={props.id} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #E0E0E0",
              borderRadius: "100px",
              pr: "10px",
            }}
          >
            <IconButton
              className={"menuBars"}
              onClick={(event) => {
                handleOpenMenu(event, "account-menu");
              }}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Box className={styles.menuIcon}>
              <img
                src={"/icons/person.svg"}
                alt="person"
                style={{ width: "18px", height: "18px" }}
              />
            </Box>
            <Menu
              id="account-menu"
              open={!!(menuState && menuState.id === "account-menu")}
              anchorEl={menuState && menuState.anchor}
              onClick={handleCloseMenu}
              onClose={handleCloseMenu}
              keepMounted={true}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              sx={{
                "& .MuiMenu-paper": {
                  borderRadius: "20px",
                  marginTop: "10px",
                },
                "& .MuiMenu-list": {
                  padding: 0,
                },
              }}
            >
              <NavbarUserMenu id={props.id} handleOpenModal={handleOpen} />
            </Menu>
          </Box>
        </Toolbar>
      </Container>

      <VerifyCertificateModal
        open={open}
        handleClose={handleClose}
        id={props.id ? props.id : "en"}
      />
    </AppBar>
  );
}

export default Navbar;
